import React, { useState } from 'react';
import Icon from '../nav/Icon';

const CARD = 'bg-white rounded-2xl border border-slate-200 p-3 md:p-4';

// search: node shown at all sizes; children: the other filter fields (folded on mobile).
// Without a search box, phones see only the Filters button until it is pressed.
const FilterPanel = ({ search, children, activeCount = 0, columns = 'lg:grid-cols-5' }) => {
  const [open, setOpen] = useState(false);
  const button = (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      aria-expanded={open}
      className={`md:hidden h-11 px-3 rounded-xl border border-slate-200 text-sm font-medium flex items-center gap-1.5 shrink-0 ${
        activeCount > 0 ? 'text-blue-700 bg-blue-50 border-blue-200' : 'text-slate-700 bg-white'
      }`}
    >
      <Icon name="filter" className="w-5 h-5" />
      {activeCount > 0 ? `Filters · ${activeCount}` : 'Filters'}
    </button>
  );
  const fields = (
    <div data-testid="filter-fields" className={`${open ? 'grid' : 'hidden'} md:grid grid-cols-1 sm:grid-cols-2 ${columns} gap-3`}>
      {children}
    </div>
  );

  if (!search) {
    return (
      <div className="space-y-3 md:space-y-0">
        <div className="flex justify-end md:hidden">{button}</div>
        <div className={`${open ? CARD : 'hidden'} md:block md:bg-white md:rounded-2xl md:border md:border-slate-200 md:p-4`}>{fields}</div>
      </div>
    );
  }

  return (
    <div className={`${CARD} space-y-3`}>
      <div className="flex gap-2">
        <div className="flex-1 min-w-0">{search}</div>
        {button}
      </div>
      {fields}
    </div>
  );
};

export default FilterPanel;
